import React, { Component } from "react";
import { Modal } from "./Model";
import { ModalAdd } from "./ModelAdd";
import TriggerButton from "./Tregger";
import { Button, Box, Typography } from "@mui/material";
export class Container extends Component {
  state = { isShown: false };
  
 
  showModal = () => {
   
    this.setState({ isShown: true }, () => {
      this.closeButton.focus();
    });
    this.toggleScrollLock();
  };
  closeModal = () => {
    this.setState({ isShown: false });
    this.TriggerButton.focus();
    this.toggleScrollLock();
  };
  onKeyDown = (event) => {
    if (event.keyCode === 27) {
      this.closeModal();
    }
  };
  onClickOutside = (event) => {
    if (this.modal && this.modal.contains(event.target)) return;
    this.closeModal();
  };

  toggleScrollLock = () => {
   
    document.querySelector("html").classList.toggle("scroll-lock");
  };
  
  render() {
   
    return(
      
      this.props.text1 === "تعديل" ? 
      <React.Fragment>
        <TriggerButton
          showModal={this.showModal}
          variant="contained"
          color="primary"
          buttonRef={(n) => (this.TriggerButton = n)}
          triggerText={this.props.triggerText}
        />
        {this.state.isShown ? (
          <Modal
           
            fundname={this.props.fundname}
            id={this.props.id}
            company={this.props.company}
            fundtype={this.props.fundtype}
            fundtype1={this.props.fundtype1}
            fundtype2={this.props.fundtype2}
            fundtype3={this.props.fundtype3}
            fundtype4={this.props.fundtype4}
            fundcompany={this.props.fundcompany}
            pricegeneral={this.props.pricegeneral}
            priceprivate={this.props.priceprivate}
            name={this.props.name}
            modalRef={(n) => (this.modal = n)}
            buttonRef={(n) => (this.closeButton = n)}
            closeModal={this.closeModal}
            onKeyDown={this.onKeyDown}
            onClickOutside={this.onClickOutside}
          />
        ) : null}
      </React.Fragment>
      : 
      <React.Fragment>
      <TriggerButton
        showModal={this.showModal}
        variant="contained"
        color="primary"
        buttonRef={(n) => (this.TriggerButton = n)}
        triggerText={this.props.triggerText}
      />
      {this.state.isShown ? (
        <ModalAdd
          fundname={this.props.fundname}
          id={this.props.id}
          company={this.props.company}
          fundtype={this.props.fundtype}
          fundtype1={this.props.fundtype1}
          fundtype2={this.props.fundtype2}
          fundtype3={this.props.fundtype3}
          fundtype4={this.props.fundtype4}
          fundcompany={this.props.fundcompany}
          pricegeneral={this.props.pricegeneral}
          priceprivate={this.props.priceprivate}
          name={this.props.name}
          modalRef={(n) => (this.modal = n)}
          buttonRef={(n) => (this.closeButton = n)}
          closeModal={this.closeModal}
          onKeyDown={this.onKeyDown}
          onClickOutside={this.onClickOutside}
        />
      ) : null}
    </React.Fragment>
    );
  }
}

export default Container;
